export const BIRTHDAY_MIN_YEAR = 1900;

export const getBirthdayMinDate = () => `${BIRTHDAY_MIN_YEAR}-01-01`;

export const getBirthdayMaxDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
